module.exports = __webpack_public_path__ + "img/glass-buildings-seen-from-lake.0e33a056.png";